import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dob-popup',
  templateUrl: './dob-popup.component.html',
  styleUrls: ['./dob-popup.component.scss']
})
export class DobPopupComponent implements OnInit {

  constructor(public dialog: MatDialogRef<DobPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {

  }

  onConfirm(){
    this.dialog.close(true)
    
  }

  closeDialog(): void {
    this.dialog.close();
  }
}
